import { Button, Row, Col, Container, Modal } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
//import App from "../../App";
import { useState } from "react";
import HandleHttpErrors from "../../HandleHttpErrors";
import { useLocation, useNavigate } from "react-router-dom";
const baseURL = process.env.REACT_APP_API_JOBS;

const EditModal = ({
  showEdit,
  setShowEdit,
  member,
  increment,
  //memberStatus,
  setMemberId,
  megdarOptions,
  handleCancelClick,
  nazeegTypeOptions,
}) => {
  const header = "עדכון פרטי הנבחן";
  const [member1, setMember1] = useState(member);
  const axiosPrivate = useAxiosPrivate("application/json");

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value, checked } = e.target;
    if (name === "active") {
      setMember1((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else
      setMember1((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "memberlist/" + member1.id + "/",
          member1,
          {
            signal: controller.signal,
          }
        );
        //isMounted && setDocuments(response.data);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    updateData();
    setMemberId(null);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  return (
    <>
      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop="static"
        keyboard={false}
        style={{
          width: "800px !important",
          margin: "10px !important",
        }}
      >
        <Modal.Header closeButton={false}>
          <Modal.Title>
            <center>
              {header +
                " " +
                member1.first_name +
                " " +
                member.last_name +
                " " +
                member1.idz}{" "}
            </center>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <Container>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>שם פרטי</label>
                    <input
                      type="text"
                      name="first_name"
                      className="form-control"
                      id="first_name"
                      value={member1.first_name}
                      placeholder=""
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>שם משפחה</label>
                    <input
                      type="text"
                      name="last_name"
                      className="form-control"
                      id="last_name"
                      value={member1.last_name}
                      placeholder=""
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>תעודת זהות</label>
                    <input
                      type="text"
                      name="idz"
                      className="form-control"
                      id="idz"
                      value={member1.idz}
                      placeholder=""
                      onChange={handleChange}
                    />
                  </div>
                </Col>

                <Col>
                  <div className="form-group">
                    <label> תאריך לידה</label>
                    <input
                      type="date"
                      name="birth_date"
                      className="form-control"
                      id="birth_date"
                      value={member1.birth_date}
                      placeholder=""
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="gender">מגדר</label>
                    <select
                      name="gender"
                      onChange={handleChange}
                      value={member1.gender}
                      required
                    >
                      <option key="0" value="" selected>
                        בחר סוג
                      </option>
                      {megdarOptions?.map((a) => (
                        <option key={a[0]} value={a[1]}>
                          {a[1]}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col></Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="Address">כתובת </label>
                    <input
                      type="text"
                      name="Address"
                      value={member1.Address}
                      onChange={handleChange}
                      className="form-control"
                      id="Address"
                      placeholder=""
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="zipcode">מיקוד</label>
                    <input
                      type="text"
                      name="zipcode"
                      value={member1.zipcode}
                      onChange={handleChange}
                      className="form-control"
                      id="zipcode"
                      placeholder=""
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>טלפון</label>
                    <input
                      type="text"
                      name="tel"
                      className="form-control"
                      id="tel"
                      value={member1.tel}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>דואר אלקטרוני</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      id="email"
                      value={member1.email}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="job">תפקיד</label>
                    <input
                      type="text"
                      name="job"
                      value={member1.job}
                      onChange={handleChange}
                      className="form-control"
                      id="job"
                      placeholder=""
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="job_place">מקום עבודה</label>
                    <input
                      type="text"
                      name="job_place"
                      className="form-control"
                      id="job_place"
                      value={member1.job_place}
                      placeholder=""
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div>
                    <label htmlFor="nazeegType">בחר סוג נציג</label>
                    <select
                      id="nazeegType"
                      name="nazeegType"
                      onChange={handleChange}
                      value={member1.nazeegType}
                    >
                      {nazeegTypeOptions?.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>פעיל</label>
                    <br />
                    <input
                      type="checkbox"
                      id="active"
                      name="active"
                      checked={member1.active}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="nazeegType">הערות</label>
                  <br />
                  <textarea
                    id="notes"
                    name="notes"
                    value={member1?.notes}
                    onChange={handleChange}
                    style={{
                      resize: "none",
                      width: "100%",
                      maxWidth: "600px",
                      height: "150px",
                    }}
                  />
                </Col>
              </Row>

              <Row>
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleSubmit}
                  >
                    שמירה
                  </button>
                </div>
                <div className="col-lg-3"></div>
                <div className="col-lg-3">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      increment();
                      setShowEdit(false);
                      setMemberId(null);
                    }}
                  >
                    סגירה
                  </Button>
                </div>
              </Row>
            </Container>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditModal;
